import * as React from 'react';
import * as ReactDom from 'react-dom';
import Notification from '../BusinessList/components/Notification';

let notificationInstance = null;
export default class NotificationService {
    toastContainer;
    constructor() {
      if (notificationInstance) {
        return notificationInstance;
      }
      notificationInstance = this;
    }

    renderToast(message, timeout = 10000) {
      const toastId = Math.random();
      const div: HTMLDivElement = document.createElement('div');
      div.id = toastId;
      // eslint-disable-next-line prefer-destructuring
      this.toastContainer = document.getElementsByClassName('site-container')[0];
      this.toastContainer.appendChild(div);
      ReactDom.render(<Notification
        message={message}
        onClose={() => div.remove()}
        timeout={timeout}
      />, document.getElementById(toastId));
    }
}



// WEBPACK FOOTER //
// ./src/modules/home/modules/browser/home/common/NotificationService.js